var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"icon-calendar"},[_c('v-icon',_vm._b({staticClass:"icon"},'v-icon',_vm.$attrs,false),[_vm._v(" $freshvue-calendar ")]),_c('span',{staticClass:"text",style:({ 'font-size': _vm.fontSize })},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }